import React, { useState, useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { TextField, Text, Stack } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpButton } from '@bingads-webui-react/help-popup';
import { ExclusionErrors } from './exclusion-errors';

const textStyles = { root: { fontWeight: 600 } };

export const IpExclusions = ({
  exclusions, placeholder, handleExclusionInputChange, errors,
}) => {
  const i18n = useContext(I18nContext);
  const [exclusionList, setExclusionList] = useState(exclusions);

  useMemo(() => {
    setExclusionList(exclusions);
  }, [exclusions]);

  const handleExclusionTextFieldChange = useCallback(
    (input) => {
      setExclusionList(input.target.value);
      handleExclusionInputChange({ value: input.target.value, type: 'ExcludedIPs' });
    },
    [setExclusionList, handleExclusionInputChange]
  );

  return (
    <div className="ip-exclusions-container">
      <Stack horizontal tokens={{ childrenGap: 4 }}>
        <Text styles={textStyles}>{i18n.getString(_TL_('IP address'))}</Text>
        <HelpButton
          aria-label={i18n.getString(_TL_('Click to learn more about IP Address'))}
          topic="Page_CampaignExclusionSettingsPopup_IPAddressToExclude"
        />
      </Stack>

      <Stack tokens={{ childrenGap: 8 }}>
        {!placeholder && (
          <Text styles={textStyles}>{i18n.getString(_TL_('Enter IP addresses or a range of IP addresses that will be blocked from seeing your ad, one IP address per line.'))}</Text>
        )}
        <TextField
          multiline
          placeholder={placeholder}
          rows={10}
          resizable={false}
          value={exclusionList || ''}
          onChange={handleExclusionTextFieldChange}
          className="ip-exclusions-textfield"
        />

        {errors && errors.length > 0 && (
          <div className="ip-exclusions-errors-container">
            <ExclusionErrors errors={errors} />
          </div>
        )}
      </Stack>
    </div>
  );
};

IpExclusions.propTypes = {
  exclusions: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  handleExclusionInputChange: PropTypes.func.isRequired,
  errors: PropTypes.shape([]),
};

IpExclusions.defaultProps = {
  errors: [],
  placeholder: '',
};
